import { render, staticRenderFns } from "./help.vue?vue&type=template&id=2722700c&scoped=true"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
import style0 from "./help.vue?vue&type=style&index=0&id=2722700c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2722700c",
  null
  
)

export default component.exports